import { gql } from 'apollo-boost'

const SEND_MENU_FOR_TESTING = gql`
  mutation sendMenuForTesting($id: ID!) {
    sendMenuForTesting(id: $id)
  }
`

export default SEND_MENU_FOR_TESTING
